const RANDOM_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

const getRandomId = (length: number) => {
    let result = "";
    for (let i = 0; i < length; i++) {
        result += RANDOM_CHARACTERS.charAt(Math.floor(Math.random() * RANDOM_CHARACTERS.length));
    }
    return result;
};

export const getClientId = () => {
    const savedUserKey = localStorage.getItem("conversation_maker_client_key");

    if (savedUserKey) {
        return savedUserKey;
    }
    const randomHashValue = getRandomId(32);
    localStorage.setItem("conversation_maker_client_key", randomHashValue);
    return randomHashValue;
};

export const isTextTruncated = (element: HTMLElement) => {
    const range = document.createRange();
    range.selectNodeContents(element);
    const textWidth = range.getBoundingClientRect().width;
    const elementWidth = element.getBoundingClientRect().width;
   
    return textWidth > elementWidth;
};
